import { render, staticRenderFns } from "./selectBanks.vue?vue&type=template&id=3883b2a4"
import script from "./selectBanks.vue?vue&type=script&lang=js"
export * from "./selectBanks.vue?vue&type=script&lang=js"
import style0 from "./selectBanks.vue?vue&type=style&index=0&id=3883b2a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports